import Vue from "vue";
import Vuex from "vuex";
import defaultUsers from "../default-users";
import { saveStatePlugin, uuid, getThisWeek } from "../utils";
import GoalService from "@/services/GoalService.js";

Vue.use(Vuex);

// TODO: hook up to dark instead of localStorage
const users = JSON.parse(localStorage.getItem("users")) || defaultUsers.users;
const week = JSON.parse(localStorage.getItem("week")) || getThisWeek();

export default new Vuex.Store({
  plugins: [saveStatePlugin],
  state: {
    week,
    users,
    goals: [],
    activeUser: {}
  },
  getters: {
    getGoalById: state => id => {
      return state.goals.find(goal => goal.goalID === id);
    }
  },
  mutations: {
    SET_GOALS(state, goals) {
      state.goals = goals;
    },
    CREATE_GOAL(state, { goal }) {
      state.goals.push(goal);
    },
    UPDATE_GOAL(state, { goal, key, value }) {
      goal[key] = value;
    },
    DELETE_GOAL(state, goalToRemove) {
      state.goals = state.goals.filter(
        goal => goal.goalID !== goalToRemove.goalID
      );
    },
    NEXT_WEEK(state) {
      state.week++;
    },
    LAST_WEEK(state) {
      state.week--;
    },
    SET_ACTIVE_USER(state, user) {
      state.activeUser = user;
    }
  },
  actions: {
    fetchGoals({ commit }) {
      return GoalService.getGoals()
        .then(r => r.data)
        .then(goals => {
          commit("SET_GOALS", goals);
        });
    },
    createGoal({ commit }, goal) {
      goal.goal.goalID = uuid();
      return GoalService.createGoal(goal.goal).then(() => {
        commit("CREATE_GOAL", goal);
      });
    },
    deleteGoal({ commit }, goal) {
      return GoalService.deleteGoal(goal.goalID).then(() => {
        commit("DELETE_GOAL", goal);
      });
    },
    updateGoal({ commit }, gkv) {
      return GoalService.updateGoal(gkv.goal, gkv.key, gkv.value).then(() => {
        commit({
          type: "UPDATE_GOAL",
          goal: gkv.goal,
          key: gkv.key,
          value: gkv.value
        });
      });
    }
  }
});
